import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logOutTempUser } from "../store/reducer/UserReducer";
import { removeToken } from "../utils/localStorageMethods";

const FromLayout = ({ children, title, width = "" ,maxWidth="970px"}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    toast.dismiss();
    toast.success(`${t("logged")} ${t("out")} ${t("successfully")}.`);
    navigate("/");
    dispatch(logOutTempUser());
    removeToken();
  };

  return (
    <>
      <div
        className="registration-wrap"
        style={{
          backgroundImage: `url(${"/./images/bg5.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        {/* background overlay */}
        <div className="bg-overlay" />

        {/* centered container */}
        <div className="d-flex align-items-center justify-content-center min-vh-100 position-relative">
          <div className={`card shadow-lg rounded-5 form-card ${width}`}>
            <div
              className="container p-0 box"
              style={{
                maxWidth: maxWidth,
                //   boxShadow: "0 4px 12px rgba(10, 0, 0, 55)",
              }}
            >
              <div
                className="card-body p-4 p-md-5 text-dark form-scroll"
                style={{
                  maxHeight: "99vh",
                  overflowY: "auto",
                }}
              >
                {/* {(location.pathname === "/registration" ||
                  location.pathname === "/payment") && (
                  <div className="text-end">
                    <Link
                      to=""
                      onClick={handleLogout}
                      className="fpLink"
                      style={{
                        color: "#f0b241",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.textDecoration = "underline")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.textDecoration = "none")
                      }
                    >
                      {t("logout")}
                    </Link>
                  </div>
                )} */}

                {/* Logo + Title */}
                <div className="text-center mb-4">
                  <img
                    src="/./images/logo.png"
                    alt="School Logo"
                    style={{
                      width: "260px",
                      height: "150px",
                      objectFit: "contain",
                      background: "transparent",
                      margin: "auto",
                      display: "block",
                    }}
                  />
                  <h4 className="fw-bold text-white mt-3 mb-3 text-center">
                    {/* Parent & Student Registration */}
                    {title}
                  </h4>
                  <hr style={{ borderTop: "2px solid #fff" }} />
                </div>

                {/* content */}
                {children}
                {/* <p
                className='text-white'
                style={{ fontSize: "15px" }}>
                2024 Aeonian Technology Corporation. All rights reserved.
                <a
                  href='#/'
                  className='hover-link ps-2'
                  style={{
                    color: "#f0b241",
                    textDecoration: "none",
                    fontWeight: "500",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.textDecoration = "underline")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.textDecoration = "none")
                  }>
                  Privacy Policy
                </a>
              </p> */}
              </div>
            </div>
          </div>
        </div>

        {/* styles */}
        <style>{`
          .bg-overlay {
            position: absolute;
            inset: 0;
            background: rgba(0, 0, 0, 0.65);
            z-index: 0;
          }
          .form-card {
            background: rgba(133, 129, 129, 0.06);
            backdrop-filter: blur(18px);
            z-index: 1;
          }
          .form-scroll::-webkit-scrollbar {
            width: 8px;
          }
          .form-scroll::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.25);
            border-radius: 8px;
          }
          .btn-amber {
            background-color: #f0b241;
            border-color: #f0b241;
            color: #fff;
          }
          .btn-amber:hover,
          .btn-amber:disabled {
            background-color: #d78b00;
            border-color: #d78b00;
            color: #fff;
          }
          .btn-blue {
            background-color: #f0b241;
            border-color: #f0b241;
            color: #fff;
          }
          .btn-blue:hover {
            background-color: #d78b00;
            border-color: #d78b00;
            color: #fff;
          }
          .btn-gray: {
            background-color: #9f9f9f;
            color: #ffff;
            border: none;
          }
          .btn-gray:hover {
            background-color: #50585f;
          }
          .btn-dark {
            --bs-btn-color: #fff;
            --bs-btn-bg: #14151661;
            --bs-btn-hover-color: #fff;
            --bs-btn-hover-bg: rgb(107, 110, 113, 0.4);
            --bs-btn-focus-shadow-rgb: 66, 70, 73;
            --bs-btn-active-color: #fff;
            --bs-btn-active-bg: rgb(77, 81, 84);
            --bs-btn-active-border-color: rgb(55, 59, 62);
            --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
            --bs-btn-disabled-color: #fff;
            --bs-btn-disabled-bg: #212529;
            --bs-btn-disabled-border-color: #212529;
          }
          .form-label {
            font-weight: 200;
            color: #fff;
          }
          .form-textarea {
            background-color: #ffffff00 !important;
            border: 1px solid #ccc !important;
            border-radius: 6px !important;
            width: 100%;
            color: #fff;
            transition: all 0.2s ease-in-out;
          }
          .form-control,
          .select__control,
          .css-13cymwt-control {
            font-weight: 200;
            background-color: #ffffff00 !important;
            border: 1px solid #ccc !important;
            border-radius: 6px !important;

            color: #fff !important;
            transition: all 0.2s ease-in-out;
          }

          .form-control:focus,
          .select__control--is-focused,
          .select__control--menu-is-open {
            background-color: #ffffff00 !important;
            border-color: #fff !important;
            box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.17) !important;
            outline: none !important;
            color: #fff !important;
          }

          .select__input-container input,
          .select__placeholder,
          .select__single-value {
            color: #fff !important;
            caret-color: #fff !important;
          }

          .form-select {
            font-weight: 200;
            background-color: rgba(255, 255, 255, 0.05) !important;
            color: #fff !important;
            border: 1px solid rgba(255, 255, 255, 0.4) !important;
            border-radius: 6px !important;
            backdrop-filter: blur(4px);
            transition: all 0.2s ease-in-out;
          }

          .form-select:focus {
            background-color: rgba(255, 255, 255, 0.1) !important;
            border-color: #ffffff !important;
            box-shadow: 0 0 0 1px #ffffff !important;
            outline: none !important;
          }

          .form-select option {
            background-color: rgba(0, 0, 0, 0.7) !important;
            color: #fff !important;
          }
          .form-control::placeholder {
            color: #ffffff !important;
            opacity: 1 !important;
          }
          .bg-gray-blur {
            background-color: #9d9d9d85 !important;
          }
          .form-check-input {
            background-color: transparent !important;
            border: 1px solid #fff !important;
          }

          .form-check-input:checked {
            background-color: #f0b241 !important;
            border-color: #f0b241 !important;
          }

          .form-check-input:focus {
          border-color: #f0b241;
            box-shadow: 0 0 0 0.2rem rgba(240, 178, 65, 0.25) !important;
          }
        `}</style>
      </div>
    </>
  );
};

export default FromLayout;
